import { TOptions } from '@if/core/i18n'
import { EApplicantType, ECreditApplicationStep, EDocumentStatus, EDocumentType, ERequiredFrom } from '@if/core/types'
import translate from '@src/services/translate'
import { FieldError } from 'react-hook-form'

export * from './constants'

export function translateErrorCode(err: FieldError, errorParams?: TOptions): string {
  if (!err) return ''
  return err.message ? translate(err.message, errorParams) : ''
}

export const EMPTY_ARRAY = []

export interface RequiredDocument {
  id: string
  applicantType: EApplicantType
  typeId: EDocumentType
  nameFr: string
  nameEn: string
  note: string
  subKey: string
  requiredBeforeStep: ECreditApplicationStep
  documentRequiredFrom: ERequiredFrom
}

export type RequiredDocumentWithStatus = RequiredDocument & {
  status: EDocumentStatus
  refusalReason: string | null
}

export type CustomError = Error & { id?: string }
